import React, { Fragment, useState, useEffect } from 'react';
import { Nav, NavItem, TabContent, TabPane } from 'reactstrap';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';
import IntlMessages from '../../../../../helpers/IntlMessages';

import UpdateReservationForm from './components/updateReservationForm';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { getAPI_GM_Settiings_List } from '../../../../../constants/APIs';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import ReservationForm from './components/ReservationForm';
import CommunicationChannels from './Communication-channels/channels';
import Application from './App-Integrations/Applications.js';
import TemplateForm from './Templates/TemplateForm.js';
import WorkOrders from './WorkOrders/index.js';

const GuestMessagingSettings = ({ propertyId, groupId, timeZone, userName }) => {
    const [activeTab, setActiveTab] = useState('reservation');
    const [loading, setLoading] = useState(false);
    const [reservationSettings, setReservationSettings] = useState(null);

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    useEffect(() => {
        if (!propertyId) {
            console.warn("propertyId not found — skipping API call.");
            return;
        }

        console.log("Fetching reservation settings for property:", propertyId, "timezone:", timeZone);
        setLoading(true);

        AxiosAPI({
            method: 'get',
            url: `${getAPI_GM_Settiings_List}/${propertyId}`,
            params: {
                group_id: getGroupID(),
                timeZone: timeZone,
            },
        })
            .then((res) => {
                console.log("Full API Response:", res);
                const payload = res?.data?.result ?? res?.data?.data?.result ?? res?.data?.data ?? res?.data ?? null;

                console.log("Extracted Payload:", payload);
                setReservationSettings(payload);
            })
            .catch((err) => {
                console.error("Error fetching reservation settings:", err);
            })
            .finally(() => setLoading(false));
    }, [propertyId, timeZone]);

    return (
        <Fragment>
            {/* Navigation Tabs */}
            <Nav tabs className="card-header-tabs separator-tabs mb-3 ml-0 mr-0">
                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'reservation',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('reservation')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'reservation'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            <IntlMessages id="guest-messaging.reservation-source" />
                        </span>
                    </NavLink>
                </NavItem>

                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'app-integrations',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('app-integrations')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'app-integrations'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            App Integrations
                        </span>
                    </NavLink>
                </NavItem>
                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'channels',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('channels')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'channels'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            <IntlMessages id="guest-messaging.communication-channels" />
                        </span>
                    </NavLink>
                </NavItem>

                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'templates',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('templates')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'templates'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            <IntlMessages id="guest-messaging.templates" />
                        </span>
                    </NavLink>
                </NavItem>

                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'link',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('link')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'link'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            <IntlMessages id="guest-messaging.link" />
                        </span>
                    </NavLink>
                </NavItem>

                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'business',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('business')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'business'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            <IntlMessages id="guest-messaging.business-profile" defaultMessage="Business Profile" />
                        </span>
                    </NavLink>
                </NavItem>

                <NavItem className="text-center" style={{ width: 'auto' }}>
                    <NavLink
                        style={{ background: 'none', cursor: 'pointer' }}
                        to="#"
                        location={{}}
                        className={classnames({
                            active: activeTab === 'workorders',
                            'nav-link': true,
                        })}
                        onClick={() => toggleTab('workorders')}
                    >
                        <span
                            style={{
                                color:
                                    activeTab === 'workorders'
                                        ? 'var(--theme-color-1)'
                                        : '#8f8f8f',
                            }}
                        >
                            Work Orders
                        </span>
                    </NavLink>
                </NavItem>
            </Nav>

            {/* Tab Content */}
            <TabContent activeTab={activeTab}>
                {/* Reservation Tab */}
                <TabPane tabId="reservation">
                    <div className="p-3">
                        {loading && <div className="loading" />}
                        {!loading && !reservationSettings && (
                            <ReservationForm initialData={null} />
                        )}
                        {!loading && reservationSettings && (
                            <UpdateReservationForm initialData={reservationSettings} />
                        )}
                    </div>
                </TabPane>

                {/* Other Tabs */}
                <TabPane tabId="app-integrations">
                    <Application propertyId={propertyId} />
                </TabPane>
                <TabPane tabId="channels">
                    <CommunicationChannels propertyId={propertyId} />
                </TabPane>

                <TabPane tabId="templates">
                    <TemplateForm propertyId={propertyId} groupId={groupId} userName={userName} />
                </TabPane>

                <TabPane tabId="link">
                    <div className="p-3">
                        <h5><IntlMessages id="guest-messaging.link" /></h5>
                    </div>
                </TabPane>

                <TabPane tabId="business">
                    <div className="p-3">
                        <h5><IntlMessages id="guest-messaging.business-profile" /></h5>
                    </div>
                </TabPane>

                <TabPane tabId="workorders">
                    <WorkOrders />
                </TabPane>
            </TabContent>
        </Fragment>
    );
};

const mapStateToProps = ({ settings }) => {
    const { propertyId, groupId, timeZone, userName } = settings;
    return { propertyId, groupId, timeZone, userName };
};

export default injectIntl(connect(mapStateToProps, {})(GuestMessagingSettings));
